<div class="flex flex-col items-center justify-center h-screen">
    <h1 class="text-4xl font-bold">Willkommen</h1>
    <p class="text-lg">Bitte warten... Sie werden automatisch weitergeleitet.</p>
    <p-progress-spinner strokeWidth="8" fill="transparent" animationDuration=".5s" [style]="{ width: '20px', height: '20px', color: 'var(--primary-color)' }" />
</div>
